export default __webpack_public_path__ + "static/media/(12).1e85a778.jpg";